import { linkToJoinClassById } from "features/dashboard/links";

import { useGetRedirectAuthenticatedUserToLocationMatches } from "./useGetRedirectAuthenticatedUserToLocationMatches";

export function useIsStudentJoinClassSignIn() {
  return useGetRedirectAuthenticatedUserToLocationMatches(
    linkToJoinClassById()
  );
}
